//============================================================================
// Name        : ls_sync.ts
// Purpose     : Implement handling LS data sync
// Created     : 2020-12-27
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import axios from "axios";
import { IChannelData, LsSyncBase } from "./ls_sync_base";

// declare const lsCheckAccessUrl: string;
declare const lsSyncPreviewUrl: string;
declare const lsSyncUrl: string;
declare const backUpStatus: string;

export class LsSync extends LsSyncBase {
    constructor() {
        super("syncDialog");
    }

    show(): void {
        this.pushingToLs = false;
        this.connectLScable(this.dialogId, (data: IChannelData) => {
            console.log(data);
            const successFinalUpdate    = "Synchronization complete";
            const successV2Update       = "Synchronization Started";
            const errorFinalUpdate      = "Error pushing data to Lightspeed";

            if (data.message.toLowerCase().includes("error")) {
                this.syncDialogDoSyncButton.prop("disabled", true);
            }

            const isFinalMessage = data.message == successFinalUpdate
                || data.message == "Sync Finished"
                || data.message == errorFinalUpdate;

            if (this.pushingToLs || isFinalMessage || data.message == successV2Update) {
                // Proceed-with-sync: keep messages in the middle status box (like preview)
                $(`#${this.dialogId} .finalStatus`).addClass("hide").hide();
                this.beginProceedSyncUi();
                this.UpdateCurrentStatus(data.message, data.inProgress, data.success);

                if (!data.inProgress) {
                    this.disconnect();
                    if (data.success) {
                        this.showRefreshBtn();
                    } else {
                        this.showProceedSyncFailedUi();
                    }
                }
                return;
            }

            // Preview phase
            $(`#${this.dialogId} .sync-actions`).hide();
            this.UpdateCurrentStatus(data.message, data.inProgress, data.success);
            if (!data.inProgress && data.success) {
                $(`#${this.dialogId} .sync-actions`).show();
                $(`#${this.dialogId} .previewSyncBtn, #${this.dialogId} .doSyncBtn`).show();
                $(`#${this.dialogId} .refreshBtn`).addClass("hidden").hide();
            }
        });

        this.syncDialogContinueButton.off("click");
        this.syncDialogContinueButton.on("click", () => { this.syncContinue(); });
        this.syncDialogDoSyncButton.off("click");
        this.syncDialogDoSyncButton.on("click",   () => { this.doSync(); });
        this.syncDialogContinueButton.show();
        $(`#${this.dialogId} .sync-actions`).hide();
        $(`#${this.dialogId} .currentStatus`).hide();
        $(`#${this.dialogId} .finalStatus`).hide();
        $("#syncDialog").modal("show");
        $("#sync-close-footer").hide();
    }

    syncContinue() {
        this.syncDialogContinueButton.hide();
        $(`#${this.dialogId} .continue-button-wrapper`).hide();
        $(`#${this.dialogId} .sync-actions`).show();
        $(`#${this.dialogId} .previewSyncBtn, #${this.dialogId} .doSyncBtn`).show();
        $(`#${this.dialogId} .refreshBtn`).addClass("hidden").hide();
        $(`#${this.dialogId} .currentStatus, #${this.dialogId} #currentStatusDesc`).removeClass("hide").show();
        $(`#${this.dialogId} .currentStatus .statusDesc`).html('Starting Quantities Import');
        $(`#${this.dialogId} .currentStatus .progress-spin`).fadeIn();
    }

    async doSync() {
        this.pushingToLs = true;
        this.syncDialogDoSyncButton.prop("disabled", true);
        this.beginProceedSyncUi();
        this.UpdateCurrentStatus("Starting Synchronization...", true, false);

        const pinCode = $("#warehouse-manager-pin").data("validated-pin") || $("#warehouse-manager-pin").val();
        const params: any = { backup_status: backUpStatus };
        if (pinCode) {
            params.warehouse_manager_pin = pinCode;
        }

        try {
            const resp = await axios.get(lsSyncUrl, { params: params });
            if (resp.status != 200) {
                this.pushingToLs = false;
                window.showErrorDialog(resp.data.message);
                this.syncDialogDoSyncButton.prop("disabled", false);
                this.showProceedSyncFailedUi();
                return;
            }
        } catch (error) {
            const axiosError = error as any;
            if (axiosError.response && axiosError.response.data && axiosError.response.data.code === 'FULL_CYCLE_COUNT_REQUIRED') {
                this.pushingToLs = false;
                const $dialog = $(`#${this.dialogId}`);
                $dialog.data('full-cycle-count-required', true);
                $dialog.find('.sync-description').addClass('hide');
                $dialog.find('#redownload-checkbox').hide();
                $dialog.find('.full-cycle-count-required').removeClass("hide");
                $dialog.find('.continue-button-wrapper').show();
                $dialog.find('.lightspeed-continue-btn').show();
                $dialog.find(".sync-actions").addClass("hide");
                $dialog.find(".currentStatus").addClass("hide");
                $dialog.find(".progress-spin").addClass("hide");
                $dialog.find(".finalStatus").hide();
                $dialog.find(".modal-footer > button[data-dismiss='modal']").show();
                if (pinCode) {
                    $dialog.find('#pin-error-message').html('Invalid PIN.<br>Please enter a valid Warehouse Manager PIN.').show();
                }
                $dialog.find('#warehouse-manager-pin').focus();
                this.syncDialogDoSyncButton.prop("disabled", false);
                return;
            }
            this.pushingToLs = false;
            window.showErrorDialog(axiosError.response?.data?.message || "An error occurred during synchronization");
            this.syncDialogDoSyncButton.prop("disabled", false);
            this.showProceedSyncFailedUi();
        }
    }
}
